import { getPrefix } from './config'

export default function register(store) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator && isAValideURL()) {
    window.addEventListener('load', registerValidSW)
  }

  function getUrlPrefix() {
    if (!process.env.PRODUCT_FINDER_ENV || process.env.PRODUCT_FINDER_ENV === 'localhost')
      return 'http://localhost:8080'
    return `https://${window.appData.id}.${process.env.PRODUCT_FINDER_ENV}`
  }
  function isAValideURL() {
    const url = window.location?.origin
    return url === getUrlPrefix()
  }

  function registerValidSW() {
    navigator.serviceWorker
      .register(`/service-worker.js`)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                store.dispatch({ type: 'PWA_NEW_CONTENT' })
              } else {
                store.dispatch({ type: 'PWA_INSTALLED' })
              }
            }
          }
        }
      })
      .catch((error) => {
        console.error('Error during service worker registration:', error)
      })
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister()
    })
  }
}
